import React, { Component } from "react";
import { Divider, Breadcrumb, Container } from "semantic-ui-react";
import { Helmet } from "react-helmet";

import { HOME_ROUTE, BASE_URL } from "../../constants/route.constants";
import { APP_NAME } from "../../constants/resource.constants";
import AdvancedSearch from "../../components/Search/Advanced/AdvancedSearch";
import NavBar from "../../components/NavBar/NavBar";
import Footer from "../../components/Footer/FooterView";

export default class FindClub extends Component {
  componentDidMount() {
    this.props.history.listen((location, action) => {
      window.scrollTo(0, 0);
    });
  }

  render() {
    return (
      <div>
        <header>
          <NavBar {...this.props} />
        </header>
        <Container>
          <Helmet>
            <title>Find a club | {APP_NAME}</title>
            <meta
              name="description"
              content="Find any international GAA club around world. All gaelic games clubs including football, hurling and camoige can be found by searching or using the controls."
            />
            <link
              rel="canonical"
              href={`${BASE_URL}${window.location.pathname}`}
            />
            <meta property="og:title" content={`Find a club | ${APP_NAME}`} />
            <meta
              property="og:description"
              content="Find any international GAA club around world. All gaelic games clubs including football, hurling and camoige can be found by searching or using the controls."
            />
            <meta
              property="og:image"
              content="https://d3hfkx84ni8spj.cloudfront.net/misc/gaa-intl-lrg.png"
            />
            <meta
              property="og:url"
              content={`${BASE_URL}${window.location.pathname}/`}
            />
            <meta property="og:type" content="website" />
          </Helmet>
          <h1>Find a club</h1>
          <Breadcrumb size="small">
            <Breadcrumb.Section href={HOME_ROUTE}>Home</Breadcrumb.Section>
            <Breadcrumb.Divider icon="right chevron" />
            <Breadcrumb.Section active>Find a club</Breadcrumb.Section>
          </Breadcrumb>
          <Divider />
          <AdvancedSearch history={this.props.history} />
        </Container>
        <Footer />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/routes/FindClub/View.js